<template>
  <main-rent :header="header" :first-available="firstAvailable" is-try-on>
    <size :rent-type="'tryOn'" />
    <delivery :rent-type="'tryOn'" />
    <rent-period :rent-type="'tryOn'" />
    <payment :rent-type="'tryOn'" />
  </main-rent>
</template>

<script>
import MainRent from './MainRent.vue'
import { Size, Delivery, RentPeriod, Payment } from 'theme/components/core/blocks/Product-v2/Rent/components'
import { mapGetters } from 'vuex'

export default {
  name: 'TryOn',
  components: {
    MainRent,
    Size,
    Delivery,
    RentPeriod,
    Payment
  },
  props: {
    firstAvailable: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      getCurrentProduct: 'product/getCurrentProduct'
    }),
    header () {
      return {
        mainTitle: 'Nie jesteś pewna rozmiaru',
        subtitle: 'Try on 2 items',
        price: this.tryOnPrice
      }
    },
    tryOnPrice () {
      let price = this.getCurrentProduct.sirental_price && this.getCurrentProduct.sirental_price.find(x => x.period === 2 + 'd')
      return price
        ? price.price
        : ''
    }
  }
}
</script>
